import * as development from "./development";
import * as production from "./production";
import * as testing from "./testing";
import * as staging from "./staging";
import * as beta from "./beta";
export const URL_DOWNLOAD_IOS = `/`;
export const URL_DOWNLOAD_ANDROID = `/`;
export default {
  development,
  testing,
  staging,
  production,
  beta
};
